import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import NewsFeed from '../components/NewsFeed.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Ipo',
  setup(__props) {

const route = useRoute()
const isDark = computed(() => (route.query.theme as string) !== 'light')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NewsFeed, {
    "is-dark": _unref(isDark),
    "special-type": 6,
    "special-code": "IPO"
  }, null, 8, ["is-dark"]))
}
}

})